/* eslint-disable react-refresh/only-export-components -- a context's provider and its read hook belong together; the hook is not a component and has no Fast Refresh state to lose. */
import { createContext, useContext } from 'react';
import type { IReplayView } from './buildReplayView';

const ReplayViewContext = createContext<IReplayView | null>(null);

interface IReplayViewProviderProps {
  value: IReplayView | null;
  children: React.ReactNode;
}

/** The Monitor page provides the replay view while a day is replayed; null is live. */
export const ReplayViewProvider: React.FC<IReplayViewProviderProps> = ({ value, children }) => (
  <ReplayViewContext.Provider value={value}>{children}</ReplayViewContext.Provider>
);

/** The replay view at the playhead, or null when live — always null outside the
 *  Monitor (the Dashboard renders the building with no provider). */
export function useReplayViewContext(): IReplayView | null {
  return useContext(ReplayViewContext);
}
